import React from 'react';
import {HashRouter, Routes, Route, Navigate} from 'react-router-dom';
import routerMap from './routerMap';


const BasicRoute = () => (
    <HashRouter>
        <Routes>
            {routerMap.map((item, index) => {
                return <Route key={index} path={item.path} element={<item.component />}>
                    {item.children?.map((v: any,i: any) => {
                        return <Route index={v.index} key={i} path={item.path == '/' ? v.path : (item.path + v.path)} element={<v.component />}></Route>
                    })}
                    <Route path='*' element={<Navigate to="/" replace />}></Route>
                </Route>
            })}
        </Routes>
    </HashRouter>
);


export default BasicRoute;